import React from "react";
import styles from "../WidgetAppearanceForm.module.css";
import {
    AppearanceTabSettingsContainer
} from "../../../../../../../elements/appearanceTabSettingsContainer/AppearanceTabSettingsContainer";
import {useAppDispatch, useAppSelector} from "../../../../../../../../app/hooks";
import {IntegerNumberValidator} from "../../../../../../../elements/validator/Validator";
import {
    MAX_FAB_BUTTONS,
    selectBubbleConvoStarters,
    selectPopUpDelaySec,
    selectPromptPopUpView,
    updateBubbleConvoStarters,
    updateSettings
} from "../../../widgetAppearanceUpdateSlice";
import {PromptButton} from "../../../../../../../elements/PromptButtonInput/PromptButton";
import {AddButton} from "../../../../../../../elements/addButton/AddButton";
import {ValidatedInputField} from "../../../../../../../elements/validator/component/ValidatedInputField";

interface PromptPopupViewProps {
    getMessageWrapper: (field: string) => string;
    updateValidationStatus: any;
}

export const PromptPopupView: React.FC<PromptPopupViewProps> = ({
                                                                    getMessageWrapper,
                                                                    updateValidationStatus
                                                                }) => {
    const dispatch = useAppDispatch();
    const promptPopUpView = useAppSelector(selectPromptPopUpView);
    const bubbleConvoStarters = useAppSelector(selectBubbleConvoStarters) || [];

    const handleAddPromptButton = () => {
        if (bubbleConvoStarters.length < MAX_FAB_BUTTONS) {
            const newButtons = [...bubbleConvoStarters, ""];
            dispatch(updateBubbleConvoStarters(newButtons));
        }
    };

    const handleUpdatePromptButton = (index: number, value: string) => {
        const newButtons = [...bubbleConvoStarters];
        newButtons[index] = value;
        dispatch(updateBubbleConvoStarters(newButtons));
    };

    const handleDeletePromptButton = (index: number) => {
        const newButtons = bubbleConvoStarters.filter((_, i) => i !== index);
        dispatch(updateBubbleConvoStarters(newButtons));
    };

    return (
        <AppearanceTabSettingsContainer
            title="Floating buttons"
            withSwitch={true}
            switchValue={promptPopUpView}
            onSwitchChange={(v) => dispatch(updateSettings({
                promptPopUpView: v
            }))}
        >
            {promptPopUpView && (
                <>
                    <div className={styles.fieldsLine}>
                        <ValidatedInputField
                            onChange={(v) => {
                                const value = Number(v);
                                if (!isNaN(value)) {
                                    dispatch(updateSettings({
                                        popUpDelaySec: value
                                    }));
                                }
                            }}
                            updateValidationStatus={updateValidationStatus}
                            fieldName="popUpDelaySec"
                            selector={selectPopUpDelaySec}
                            validator={IntegerNumberValidator}
                            label="Intro delay (seconds)"
                            placeholder="e.g., 20"
                            getMessage={getMessageWrapper}
                            required={false}
                        />
                    </div>
                    <div>
                        <label className={styles.promptButtonsLabel}>Buttons</label>
                        <div className={styles.promptButtonsList}>
                            {bubbleConvoStarters.map((button, index) => (
                                <PromptButton
                                    key={index}
                                    value={button}
                                    onChange={(value) => handleUpdatePromptButton(index, value)}
                                    onDelete={() => handleDeletePromptButton(index)}
                                    maxLength={30}
                                    placeholder={`Placeholder ${index + 1}`}
                                />
                            ))}
                        </div>

                        <AddButton
                            onClick={handleAddPromptButton}
                            isEnabled={bubbleConvoStarters.length < MAX_FAB_BUTTONS}
                            text="Add button"
                        />
                    </div>
                </>
            )}
        </AppearanceTabSettingsContainer>
    );
};
